import { render, staticRenderFns } from "./StudentGradeModal.vue?vue&type=template&id=324291e7"
import script from "./StudentGradeModal.vue?vue&type=script&lang=js"
export * from "./StudentGradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('324291e7')) {
      api.createRecord('324291e7', component.options)
    } else {
      api.reload('324291e7', component.options)
    }
    module.hot.accept("./StudentGradeModal.vue?vue&type=template&id=324291e7", function () {
      api.rerender('324291e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/studentGrade/modules/StudentGradeModal.vue"
export default component.exports